import React from 'react';
import PropTypes from 'prop-types';
import styles from './ActivationServices.module.scss';
import { CarrierDisplayName } from '../../../constants/carrierTypes';

function ActivationServices(props) {
  const { supplierData } = props;

  const paymentMethod = (billingMethod) => {
    if (!billingMethod) {
      return null;
    }
    const method = billingMethod === 'none' ? 'Based On Invoice' : 'Credit Card / Bank Transfer';

    return `Payment method: ${method}`;
  };

  const shippingCost = (shipperAccountType, shipperAccount, shippingCost) => {
    const shippingCostTerms = [];

    if (shipperAccountType) {
      const type = CarrierDisplayName[shipperAccountType] || 'None';
      shippingCostTerms.push(
        <li key="shipperAccount">
          Using Shipper Account: {shipperAccount} ({type})
        </li>,
      );
    } else {
      if (shippingCost[0].percentage > 0) {
        shippingCostTerms.push(
          <li key="shippingCostPercentage"> Shipping cost: {shippingCost[0].percentage}% per item</li>,
        );
      }
      if (shippingCost[0].fixed_per_unit > 0) {
        shippingCostTerms.push(
          <li key="shippingCostFixed"> Shipping cost: {shippingCost[0].fixed_per_unit / 100} per unit</li>,
        );
      }
    }
    return shippingCostTerms;
  };

  const serviceActive = (value) => {
    return (
      <span className={value ? styles.active : styles.notActive}>
        {value ? ' SERVICE IS ACTIVE' : ' SERVICE IS NOT ACTIVE'}
      </span>
    );
  };

  const revenue = () => {
    const formula = supplierData.ecommerce_unit_price_formula;

    if (formula && formula.includes('retail_price')) {
      const percentageRegex = /^retail_price\*(\d+)\/100$/;
      const parts = formula.match(percentageRegex);
      if (parts) {
        return `Revenue share based on retail price: ${100 - parts[1]}%`;
      }
    }

    return 'Prices are based on agreed wholesale prices';
  };

  const {
    approved_for_ecommerce,
    approved_for_replenishment,
    ecommerce_billing_method,
    minimum_products_for_replenishment_order,
    minimum_order_value_for_replenishment_order,
    replenish_billing_method,
    replenishment_order_shipping_cost,
    replenishment_shipper_account_type,
    replenishment_shipper_account,
  } = supplierData;

  return (
    <div className={styles.container}>
      <div>
        <div className={styles.body}>
          <span>DROP SHIP TERMS - {serviceActive(approved_for_ecommerce)}</span>

          <li>{revenue()}</li>
          <li> No additional shipping cost, handing fees or return costs are applicable.</li>
          <li>{paymentMethod(ecommerce_billing_method)}</li>

          {!approved_for_ecommerce ? (
            <div>
              <span>TO ACTIVATE:</span>
              <p>1. Add eCom integration.</p>
              <p>2. Add credit card.</p>
            </div>
          ) : null}
        </div>
      </div>
      <div>
        <div className={styles.body}>
          <span>REORDER TERMS - {serviceActive(approved_for_replenishment)}</span>

          {shippingCost(
            replenishment_shipper_account_type,
            replenishment_shipper_account,
            replenishment_order_shipping_cost,
          )}

          {minimum_products_for_replenishment_order ? (
            <li> Minimum units/cases per order: {minimum_products_for_replenishment_order}</li>
          ) : null}

          {minimum_order_value_for_replenishment_order ? (
            <li> Minimum value per order: {minimum_order_value_for_replenishment_order}</li>
          ) : null}

          <li>{paymentMethod(replenish_billing_method)}</li>
        </div>
      </div>
    </div>
  );
}

export default ActivationServices;

ActivationServices.propTypes = {
  supplierData: PropTypes.object.isRequired,
};
